var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeLow = function SvgVolumeLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.433 7.091a.6.6 0 0 1 .84-.12 2.536 2.536 0 0 1 0 4.058.6.6 0 1 1-.72-.96 1.335 1.335 0 0 0 0-2.138.6.6 0 0 1-.12-.84ZM9.206 2.538a1.2 1.2 0 0 1 1.644 1.254v10.416a1.2 1.2 0 0 1-2.227.749L6.207 11.85H5a1.35 1.35 0 0 1-1.35-1.35v-3A1.35 1.35 0 0 1 5 6.15h1.207l2.416-3.107a1.2 1.2 0 0 1 .583-.505Zm.393 1.205L6.974 7.118a.6.6 0 0 1-.474.232H5a.15.15 0 0 0-.15.15v3a.15.15 0 0 0 .15.15h1.5a.6.6 0 0 1 .474.232l2.625 3.375a.6.6 0 0 1 .06.093.599.599 0 0 1-.009-.1V3.75a.6.6 0 0 1 .008-.1.601.601 0 0 1-.06.093Z"
  }))));
};
export default SvgVolumeLow;